import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import footerLogo from '../../../img/footer-logo.svg';

import ENSimage from '../../../img/certificates/ENSCertificate-alta.png';
import LRQAcertificate from '../../../img/certificates/LRQAcertificate.png';
import SAPcertificate from '../../../img/certificates/SAPcertificate.png';
import ENSpdf from '../../../files/CERTIFICADO_ENS_EQUINIX_SPAIN_ENTERPRISES_signed.pdf';

import 'style/components/ui/footer.scss';

const Footer = () => <Row className="footerContainer">
    <Col md={12} className="footerElements">
        <img src={footerLogo} alt="logo" />
        <span>© 2024 Equinix, Inc. All rights reserved.</span>
        <div className="footerImages">
            <a href={ENSpdf}
                target="_blank"
                rel="noopener noreferrer"
                className="footerLink"
            >
                <img src={ENSimage} alt="ENS certificate" title="ENS certificate - Alta" className="footerImageHeight" />
            </a>
            <img src={LRQAcertificate} alt="LRQA certificates" title="LRQA certificate" className="footerImageHeight" />
            <img src={SAPcertificate} alt="SAP certificate" title="SAP certificate" className="footerImageWidth" />
        </div>
    </Col>
</Row>;

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/components/ui/layout/Footer.jsx